import Axios from "axios";

const apiURL = /myrace.info/.test(window.location.hostname)
  ? "https://photo-api.myrace.info/rpc"
  : /kadr.app/.test(window.location.hostname)
    ? "https://api.kadr.app/rpc"
    : "https://api.portreed.com/rpc";

const axios = Axios.create({
  baseURL: apiURL,
  withCredentials: true,
});

function getErrorMessage(error, fallbackMessage = "Request failed") {
  const responseData =
    error && error.response && error.response.data ? error.response.data : null;

  return (
    (responseData && (responseData.error || responseData.message)) ||
    (error && error.message) ||
    fallbackMessage
  );
}

export default {
  async getAlbumInfo(albumId) {
    const response = await axios.get("/album/getSettings", {
      params: { albumId },
    });

    return response.data
      ? {
          id: response.data.id,
          name: response.data.name,
          caption: response.data.caption,
          sealed: response.data.sealed,
        }
      : null;
  },

  async authenticatedUser() {
    return (await axios.get("/auth/me")).data;
  },

  async endSession() {
    await axios.post("/auth/endSession");
  },

  async sendOTP(email) {
    return await axios.post("/auth/sendOtp", { email });
  },

  async redeemOTP(email, code) {
    try {
      const response = await axios.post("/auth/redeemOtp", { email, code });
      return response.data.item;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Invalid one-time password"));
    }
  },

  async createUpload(matterId, itemsCount) {
    try {
      const response = await axios.post("/upload/start", {
        albumId: matterId,
        itemsCount,
      });

      if (response.data && response.data.error) {
        throw new Error(response.data.error);
      }

      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async getS3Credentials(uploadId) {
    return (await axios.post("/upload/getCredentials", { uploadId })).data;
  },

  async finishUpload(uploadId) {
    return (await axios.post("/upload/startProcessing", { uploadId })).data;
  },

  async getAlbumItemsStatus(albumId) {
    return (
      await axios.get("/upload/getAlbumItemsStatus", {
        params: { albumId },
      })
    ).data;
  },
};
